import React, { useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

const EDGE = 8;

// Shown on hover or keyboard focus, drawn over the page so a table's scroll area or a modal never cuts it off. It sits
// above the element (below when there's no room), kept inside the screen.
const Tooltip = ({ text, tooltip, className = "" }) => {
  const [place, setPlace] = useState(null);
  const triggerRef = useRef();
  const tipRef = useRef();
  const arrowRef = useRef();

  const show = () => {
    const box = triggerRef.current.getBoundingClientRect();
    const above = box.top > 48;
    setPlace({ center: box.left + box.width / 2, top: above ? box.top - EDGE : box.bottom + EDGE, above });
  };
  const hide = () => setPlace(null);

  useLayoutEffect(() => {
    if (!place || !tipRef.current) return;
    const { width } = tipRef.current.getBoundingClientRect();
    const left = Math.min(Math.max(place.center - width / 2, EDGE), window.innerWidth - width - EDGE);
    tipRef.current.style.left = `${left}px`;
    arrowRef.current.style.left = `${place.center - left}px`;
  }, [place]);

  return (
    <span
      ref={triggerRef}
      className="inline-flex"
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
      onClickCapture={hide}
    >
      {text}
      {place &&
        tooltip &&
        createPortal(
          <div
            ref={tipRef}
            role="tooltip"
            className={`pointer-events-none fixed max-w-xs rounded bg-gray-800 px-2 py-1 text-xs text-white shadow-lg whitespace-normal break-words ${className}`}
            style={{ top: place.top, transform: place.above ? "translateY(-100%)" : "none", zIndex: 100000 }}
          >
            {tooltip}
            <span
              ref={arrowRef}
              className="absolute h-2 w-2 -translate-x-1/2 rotate-45 bg-gray-800"
              style={place.above ? { bottom: -4 } : { top: -4 }}
            />
          </div>,
          document.body,
        )}
    </span>
  );
};

export default Tooltip;
